module.exports = __webpack_public_path__ + "img/9788937833236.4b050986.jpg";